import {
  Companion_getInstance173agu3fofr81 as Companion_getInstance,
  UploadForNextRequest3ny2xmglqmyrv as UploadForNextRequest,
} from './UploadEarlyEndpointModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from './ServerFile.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../DefaultClock.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstancejlptjvjgjkm8 as DurationUnit_MINUTES_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareUploadForNextRequestFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [UploadForNextRequest__id_getInstance(), UploadForNextRequest_file_getInstance(), UploadForNextRequest_expires_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function UploadForNextRequest__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function UploadForNextRequest__id$_get_name_$ref_l5jj9g() {
  return (p0) => p0.i20();
}
function UploadForNextRequest__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UploadForNextRequest__id$_get_serializer_$ref_ybjcil() {
  return (p0) => p0.h2j();
}
function UploadForNextRequest__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function UploadForNextRequest__id$_get_annotations_$ref_hmq455() {
  return (p0) => p0.bz();
}
var UploadForNextRequest__idClass;
function UploadForNextRequest__id() {
  if (UploadForNextRequest__idClass === VOID) {
    class $ {
      constructor() {
        UploadForNextRequest__id_instance = this;
        var tmp = this;
        tmp.x35_1 = lazy(UploadForNextRequest__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y35_1 = lazy(UploadForNextRequest__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z35_1 = lazy(UploadForNextRequest__id$annotations$delegate$lambda);
        this.a36_1 = Companion_getInstance_0().k2p();
        this.b36_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.x35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UploadForNextRequest__id$_get_name_$ref_l5jj9g(), null);
        return tmp0.f2();
      }
      c36(receiver) {
        return receiver.d36_1;
      }
      k2j(receiver) {
        return this.c36(receiver instanceof UploadForNextRequest() ? receiver : THROW_CCE());
      }
      g36(receiver, value) {
        return receiver.h36(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UploadForNextRequest() ? receiver : THROW_CCE();
        return this.g36(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UploadForNextRequest__id$_get_serializer_$ref_ybjcil(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UploadForNextRequest__id$_get_annotations_$ref_hmq455(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'UploadForNextRequest__id', VOID, VOID, [SerializableProperty()]);
    UploadForNextRequest__idClass = $;
  }
  return UploadForNextRequest__idClass;
}
var UploadForNextRequest__id_instance;
function UploadForNextRequest__id_getInstance() {
  if (UploadForNextRequest__id_instance === VOID)
    new (UploadForNextRequest__id())();
  return UploadForNextRequest__id_instance;
}
function UploadForNextRequest_file$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function UploadForNextRequest_file$_get_name_$ref_w6v88k() {
  return (p0) => p0.i20();
}
function UploadForNextRequest_file$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UploadForNextRequest_file$_get_serializer_$ref_pt0ior() {
  return (p0) => p0.h2j();
}
function UploadForNextRequest_file$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function UploadForNextRequest_file$_get_annotations_$ref_yqwk3l() {
  return (p0) => p0.bz();
}
var UploadForNextRequest_fileClass;
function UploadForNextRequest_file() {
  if (UploadForNextRequest_fileClass === VOID) {
    class $ {
      constructor() {
        UploadForNextRequest_file_instance = this;
        var tmp = this;
        tmp.i36_1 = lazy(UploadForNextRequest_file$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j36_1 = lazy(UploadForNextRequest_file$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k36_1 = lazy(UploadForNextRequest_file$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.i36_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UploadForNextRequest_file$_get_name_$ref_w6v88k(), null);
        return tmp0.f2();
      }
      l36(receiver) {
        return receiver.e36_1;
      }
      k2j(receiver) {
        return new (ServerFile())(this.l36(receiver instanceof UploadForNextRequest() ? receiver : THROW_CCE()));
      }
      m36(receiver, value) {
        return receiver.h36(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UploadForNextRequest() ? receiver : THROW_CCE();
        return this.m36(tmp, value instanceof ServerFile() ? value.l2n_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.j36_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UploadForNextRequest_file$_get_serializer_$ref_pt0ior(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k36_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UploadForNextRequest_file$_get_annotations_$ref_yqwk3l(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'UploadForNextRequest_file', VOID, VOID, [SerializableProperty()]);
    UploadForNextRequest_fileClass = $;
  }
  return UploadForNextRequest_fileClass;
}
var UploadForNextRequest_file_instance;
function UploadForNextRequest_file_getInstance() {
  if (UploadForNextRequest_file_instance === VOID)
    new (UploadForNextRequest_file())();
  return UploadForNextRequest_file_instance;
}
function UploadForNextRequest_expires$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function UploadForNextRequest_expires$_get_name_$ref_ilgemi() {
  return (p0) => p0.i20();
}
function UploadForNextRequest_expires$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UploadForNextRequest_expires$_get_serializer_$ref_x2uzqb() {
  return (p0) => p0.h2j();
}
function UploadForNextRequest_expires$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function UploadForNextRequest_expires$_get_annotations_$ref_exexhd() {
  return (p0) => p0.bz();
}
var UploadForNextRequest_expiresClass;
function UploadForNextRequest_expires() {
  if (UploadForNextRequest_expiresClass === VOID) {
    class $ {
      constructor() {
        UploadForNextRequest_expires_instance = this;
        var tmp = this;
        tmp.n36_1 = lazy(UploadForNextRequest_expires$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o36_1 = lazy(UploadForNextRequest_expires$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p36_1 = lazy(UploadForNextRequest_expires$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        var tmp_3 = get_default(Companion_instance).b1m();
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance_1();
        var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
        tmp_2.q36_1 = tmp_3.s26(tmp$ret$1);
        this.r36_1 = 'now().plus(15.minutes)';
      }
      i20() {
        var tmp0 = this.n36_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UploadForNextRequest_expires$_get_name_$ref_ilgemi(), null);
        return tmp0.f2();
      }
      c36(receiver) {
        return receiver.f36_1;
      }
      k2j(receiver) {
        return this.c36(receiver instanceof UploadForNextRequest() ? receiver : THROW_CCE());
      }
      s36(receiver, value) {
        return receiver.h36(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UploadForNextRequest() ? receiver : THROW_CCE();
        return this.s36(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.o36_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UploadForNextRequest_expires$_get_serializer_$ref_x2uzqb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p36_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UploadForNextRequest_expires$_get_annotations_$ref_exexhd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'UploadForNextRequest_expires', VOID, VOID, [SerializableProperty()]);
    UploadForNextRequest_expiresClass = $;
  }
  return UploadForNextRequest_expiresClass;
}
var UploadForNextRequest_expires_instance;
function UploadForNextRequest_expires_getInstance() {
  if (UploadForNextRequest_expires_instance === VOID)
    new (UploadForNextRequest_expires())();
  return UploadForNextRequest_expires_instance;
}
//region block: exports
export {
  prepareUploadForNextRequestFields as prepareUploadForNextRequestFieldsxbhgnoa28aao,
};
//endregion

//# sourceMappingURL=UploadForNextRequestFields.mjs.map
